import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=5f253a5a&scoped=true&"
import script from "./MentionList.vue?vue&type=script&lang=js&"
export * from "./MentionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f253a5a",
  null
  
)

export default component.exports